import { mapEnumValueToDisplayable } from "../shared/model/GameUtils"

export default function AnswerButtons({onClick = () => {}, disableAll = false, disableJoker = false}) {
  return (
    <div className="horizontal-container gap-2 fixed-container center">
      <button className="fixed-container" onClick={() => onClick("RIGHT")} disabled={disableAll}>
        {mapEnumValueToDisplayable("RIGHT")}
      </button>
      <button className="fixed-container" onClick={() => onClick("WRONG")} disabled={disableAll}>
        {mapEnumValueToDisplayable("WRONG")}
      </button>
      <button className="fixed-container" onClick={() => onClick("JOKER")} disabled={disableJoker || disableAll}>
        {mapEnumValueToDisplayable("JOKER")}
      </button>
    </div>
  )
}